var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25545",
    "data-name": "Group 25545",
    transform: "translate(-190 -163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25532",
    "data-name": "Group 25532",
    transform: "translate(-1066 -956)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_002-users",
    "data-name": "002-users",
    transform: "translate(194 142.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12008",
    "data-name": "Group 12008",
    transform: "translate(0.001 25.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M11.611,31.727a3.574,3.574,0,0,0-4.447-5.579,3.575,3.575,0,0,0-4.452,5.579A5.079,5.079,0,0,0,0,36.241v1.534a.511.511,0,0,0,.511.511h13.3a.511.511,0,0,0,.511-.511V36.241A5.079,5.079,0,0,0,11.611,31.727Zm-3.536-.361c-.051-.025-.1-.046-.148-.074l.011-.016a3.588,3.588,0,0,0,.548-1l.016-.043a3.608,3.608,0,0,0,.136-.526c0-.026.008-.051.012-.079a3.265,3.265,0,0,0,0-1.1c0-.027-.008-.051-.012-.079a3.609,3.609,0,0,0-.136-.526l-.016-.043a3.589,3.589,0,0,0-.548-1l-.011-.016a2.553,2.553,0,1,1,2.331,4.536l-.119.051a2.507,2.507,0,0,1-.389.121c-.026.006-.051.009-.077.014a2.559,2.559,0,0,1-.45.046c-.068,0-.137-.005-.2-.011a.387.387,0,0,1-.077-.005,2.584,2.584,0,0,1-.836-.247C8.1,31.37,8.084,31.37,8.075,31.366Zm5.224,5.9H10.23V36.241c0-.16-.009-.319-.024-.476,0-.046-.011-.092-.016-.138-.014-.113-.03-.225-.051-.336q-.014-.071-.029-.143-.037-.171-.085-.339c-.011-.037-.02-.074-.032-.11a5.068,5.068,0,0,0-.616-1.292l-.02-.029q-.132-.2-.282-.379l0,0a4.644,4.644,0,0,0-.33-.367h.021a3.62,3.62,0,0,0,.435.031h.028a3.621,3.621,0,0,0,.4-.026c.042-.005.083-.013.125-.019q.163-.025.322-.065l.092-.024a3.482,3.482,0,0,0,.409-.139A4.066,4.066,0,0,1,13.3,36.241v1.023Z",
    transform: "translate(-0.001 -25.494)",
    fill: "#7f8a90"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryIcon);
export default __webpack_public_path__ + "static/media/directory-icon.6a1d323a319ec9f947bc2eb065d55b20.svg";
export { ForwardRef as ReactComponent };